import { writable } from 'svelte/store'

/**
 * Represents the authenticated state of the user, true when a user is authenticated, false by default.
 * @type {import('svelte/store').Writable<boolean>}
 */
export const isAuthenticated = writable(false)

/**
 * Represents the details of an authenticated user returned by Auth0 after successful authentication.
 * @type {import('svelte/store').Writable<{
 *   cn_roles: string[]?;
 *   email: string?;
 *   email_verified: boolean?;
 *   name: string;
 *   nickname: string;
 *   picture: string;
 *   sub : string;
 *   updated_at: string?;
 * } | undefined>}
 */
export const user = writable(undefined)

// allow for testing porpouses the access to the user for the auth0
if (process.env.NODE_ENV !== 'production') {
  // @ts-ignore
  window.user = user // set the user from the store for testing porpouses
}

/**
 * Represents the error information if the authentication process fails.
 * @type {import('svelte/store').Writable<Error>}
 */
export const error = writable()

function createLocalStore(key) {
  const storedValue = localStorage.getItem(key)
  const initialValue = storedValue !== null ? JSON.parse(storedValue) : undefined

  const { subscribe, set, update } = writable(initialValue)

  return {
    subscribe,
    set: value => {
      localStorage.setItem(key, JSON.stringify(value))
      set(value)
    },
    update,
  }
}

/**
 * @typedef {Object} EmulateUser?
 * @property {string} email - Emulated user's email address.
 * @property {string} firstName - Emulated user's first name.
 * @property {string} lastName - Emulated user's last name.
 */

export const emulateUser = createLocalStore('emulateUser')
